/**
 * 集团营收分析三 Tab 共用布局常量（顶栏响应式、折线图最小高度等）。
 */

/** 三 Tab 折线图绘制区高度（px）；小屏纵向滚动时保证 Apex 有明确高度可渲染 */
export const GROUP_REVENUE_LINE_CHART_MIN_HEIGHT_PX = 280;

/**
 * 集团营业总额 Tab：视口宽度 ≥ 此值时保持左右双栏；低于此值（如平板）改为单列纵向堆叠。
 * 与 MUI theme `breakpoints.lg`（1280）一致。
 */
export const GROUP_REVENUE_TOTAL_TAB_TWO_COLUMN_MIN_WIDTH_PX = 1280;

/**
 * 集团营业总额 Tab：视口高度 ≥ 此值且宽度 ≥ {@link GROUP_REVENUE_TOTAL_TAB_TWO_COLUMN_MIN_WIDTH_PX} 时拉满内容区、左右栏等高。
 */
export const GROUP_REVENUE_TOTAL_TAB_FILL_VIEWPORT_MIN_HEIGHT_PX = 720;

/** 多门店数据对比 Tab：折线图外卡最小高度（px，含标题、图例与绘图区）；大屏下可 flex 伸展更高 */
export const GROUP_REVENUE_MULTI_STORE_LINE_CHART_CARD_MIN_HEIGHT_PX = 480;

/**
 * 多门店数据对比 Tab：视口高度 ≥ 此值时 Tab 拉满内容区，折线外卡 flex 伸展（复用与营业总额相同的视口阈值）。
 */
export const GROUP_REVENUE_MULTI_STORE_TAB_FILL_VIEWPORT_MIN_HEIGHT_PX =
    GROUP_REVENUE_TOTAL_TAB_FILL_VIEWPORT_MIN_HEIGHT_PX;

/**
 * 集团菜单销售分析 Tab：视口高度 ≥ 此值且宽度 ≥ {@link GROUP_REVENUE_TOTAL_TAB_TWO_COLUMN_MIN_WIDTH_PX} 时拉满内容区，左折线卡与右排名卡等高伸展。
 */
export const GROUP_REVENUE_DISH_SALES_TAB_FILL_VIEWPORT_MIN_HEIGHT_PX =
    GROUP_REVENUE_TOTAL_TAB_FILL_VIEWPORT_MIN_HEIGHT_PX;

/** 集团菜单销售分析 Tab：双栏最小视口宽度，与 Tab0 共用 1280（MUI lg） */
export const GROUP_REVENUE_DISH_SALES_TAB_TWO_COLUMN_MIN_WIDTH_PX =
    GROUP_REVENUE_TOTAL_TAB_TWO_COLUMN_MIN_WIDTH_PX;
